import BrowserLogger from './strategies/browser-strategy';

/**
 * Enforces that logging is invoked using one the following forms:
 * ```
 * // logs { "msg":"Message" }
 * logger.info('Message');
 *
 * // logs { "context": "value", "msg": "Message" }
 * logger.info({ context: 'value' }, 'Message');
 * ```
 *
 * Using alternative invocations with the server logger creates log entries that are harder to filter in Splunk:
 * ```
 * // logs { "msg": "Message { context: 'value' }" }
 * logger.info('Message', { context: 'value' });
 * ```
 */
type ILogger = {
    [_ in keyof typeof BrowserLogger]: (
        contextOrMsg: unknown,
        msg?: string
    ) => void;
};

const Logger: ILogger = {
    ...BrowserLogger
};

export default Logger;
